












import { Component, Vue, Provide } from 'vue-property-decorator'
import { namespace } from 'vuex-class'
import { Tabs, Tab, List } from 'vant'
import { findIndex, startsWith } from 'lodash'
import SearchBar from './components/common/search_bar.vue'
import SearchAll from './components/searchAll/index.vue'
import { getSelectedCityId, unbind } from '@utils/index'

const searchResModule = namespace('searchRes') //vuex
const TabsDef = ['全部', '景点', '研学', '酒店', '商家', '商品', '月嫂', '育儿顾问']

window._TRACK_EXPOSURE = true //当前页面开启自动曝光监控

@Component({
  components: {
    'search-bar': SearchBar,
    [Tabs.name]: Tabs,
    [Tab.name]: Tab,
    [List.name]: List,
    SearchAll,
    SearchBusiness: () => import('./components/searchBusiness/index.vue'),
    SearchProduct: () => import('./components/searchProduct/index.vue'),
    SearchYueSao: () => import('./components/searchYueSao/index.vue'),
    SearchYuer: () => import('./components/searchYuer/index.vue'),
    SearchHotel: () => import('./components/searchHotel/index.vue'),
    SearchStudy: () => import('./components/searchStudy/index.vue'),
    SearchThirdPartScenic: () => import('./components/searchThirdPartScenic/index.vue')
  }
})
export default class SearchRes extends Vue {
  fromSearchPage = false //标识前一个页面是否是搜索前置页
  tabSelect = 0 //tab索引
  tabsTmp: Array<string> = [] //记录tab标题
  searchKey = '' //搜索关键字
  errormsg = '' //searchall组件接口报错信息

  //vuex 声明
  @searchResModule.State businessNum!: number | null
  @searchResModule.State productNum!: number | null
  @searchResModule.State yueSaoNum!: number | null
  @searchResModule.State yuerNum!: number | null
  @searchResModule.State thirdPartScenicNum!: number | null
  @searchResModule.State researchStudyNum!: number | null
  @searchResModule.State hotelNum!: number | null

  @searchResModule.Action getSearchResAction!: (par: { navid: string | number }) => Promise<any>
  @searchResModule.Action getDistrictListByCityCode!: () => Promise<any>
  @searchResModule.Mutation setBusinessNum!: (arg: number | null) => void
  @searchResModule.Mutation setProductNum!: (arg: number | null) => void
  @searchResModule.Mutation setYueSaoNum!: (arg: number | null) => void
  @searchResModule.Mutation setYuerNum!: (arg: number | null) => void
  @searchResModule.Mutation setThirdPartScenicNum!: (arg: number | null) => void
  @searchResModule.Mutation setResearchStudyNum!: (arg: number | null) => void
  @searchResModule.Mutation setHotelNum!: (arg: number | null) => void

  @Provide()
  pageTrackParams: any = {
    bizType: '127',
    pageLevelId: '121012976',
    pageParam: { citycode: getSelectedCityId(), keyword: this.$route.query && this.$route.query.searchKey }
  }
  @Provide()
  clickid_200019 = '200019'
  @Provide()
  clickid_200018 = '200018'
  @Provide()
  clickid_200017 = '200017'
  @Provide()
  clickid_200016 = '200016'
  @Provide()
  clickid_200015 = '200015'
  @Provide()
  clickid_200014 = '200014'
  @Provide()
  clickid_200013 = '200013'
  @Provide()
  clickid_200012 = '200012'
  @Provide()
  clickid_200011 = '200011'
  @Provide()
  clickid_200010 = '200010'
  @Provide()
  clickid_200009 = '200009'
  @Provide()
  clickid_200008 = '200008'

  beforeRouteEnter(to: any, from: any, next: (vm: any) => void): void {
    next((vm: any) => {
      vm.fromSearchPage = false
      if (from.name === 'search') {
        //从search过来 重新刷数据
        to.meta.keepAlive = false
        vm.fromSearchPage = true
      }
    })
  }

  async created() {
    this.$setTitle('搜索')
    const { searchKey } = this.$route.query
    this.searchKey = searchKey as string
    // this.$tracker('127', '121012976')({ citycode: getSelectedCityId(), keyword: this.searchKey })
    this.getDistrictListByCityCode()
  }

  refresh(num: number | null) {
    //num为null会执行重新加载组件
    this.setBusinessNum(num)
    this.setProductNum(num)
    this.setYueSaoNum(num)
    this.setYuerNum(num)
    this.setThirdPartScenicNum(num)
    this.setHotelNum(num)
    this.setResearchStudyNum(num)
  }

  errorHandler(result: any) {
    this.refresh(0)

    const { msg } = result
    this.errormsg = msg
  }

  get tabsArray() {
    //首次默认加载全部
    if (this.businessNum === null || this.productNum === null || this.yueSaoNum === null || this.yuerNum === null || this.thirdPartScenicNum === null || this.researchStudyNum === null || this.hotelNum === null) {
      return TabsDef
    }

    //tabsTmp有值 标识已经完成首次加载且数据不全为空
    const tabsName = this.tabsTmp.join()
    let tabs: string[] = []
    const all = this.businessNum + this.productNum + this.yueSaoNum + this.yuerNum + this.thirdPartScenicNum
    if (all > 0) {
      tabs.push('全部')
    } else {
      if (this.tabsTmp.length > 0 && tabsName.indexOf('全部') != -1) {
        tabs.push('全部')
      }
    }

    if (this.thirdPartScenicNum > 0) {
      tabs.push(`景点(${this.thirdPartScenicNum > 99 ? '99+' : this.thirdPartScenicNum})`)
    } else {
      if (this.tabsTmp.length > 0 && tabsName.indexOf('景点') != -1) {
        tabs.push('景点')
      }
    }

    if (this.researchStudyNum > 0) {
      tabs.push(`研学(${this.researchStudyNum > 99 ? '99+' : this.researchStudyNum})`)
    } else {
      if (this.tabsTmp.length > 0 && tabsName.indexOf('研学') != -1) {
        tabs.push('研学')
      }
    }

    if (this.hotelNum > 0) {
      tabs.push(`酒店(${this.hotelNum > 99 ? '99+' : this.hotelNum})`)
    } else {
      if (this.tabsTmp.length > 0 && tabsName.indexOf('酒店') != -1) {
        tabs.push('酒店')
      }
    }

    if (this.productNum > 0) {
      tabs.push(`商品(${this.productNum > 99 ? '99+' : this.productNum})`)
    } else {
      if (this.tabsTmp.length > 0 && tabsName.indexOf('商品') != -1) {
        tabs.push('商品')
      }
    }

    if (this.businessNum > 0) {
      tabs.push(`商家(${this.businessNum > 99 ? '99+' : this.businessNum})`)
    } else {
      if (this.tabsTmp.length > 0 && tabsName.indexOf('商家') != -1) {
        tabs.push('商家')
      }
    }

    if (this.yueSaoNum > 0) {
      tabs.push(`月嫂(${this.yueSaoNum > 99 ? '99+' : this.yueSaoNum})`)
    } else {
      if (this.tabsTmp.length > 0 && tabsName.indexOf('月嫂') != -1) {
        tabs.push('月嫂')
      }
    }

    if (this.yuerNum > 0) {
      tabs.push(`育儿顾问(${this.yuerNum > 99 ? '99+' : this.yuerNum})`)
    } else {
      if (this.tabsTmp.length > 0 && tabsName.indexOf('育儿顾问') != -1) {
        tabs.push('育儿顾问')
      }
    }

    this.tabsTmp = []
    this.tabsTmp.push(...tabs)

    return tabs
  }

  get getComponentName() {
    return (idx: number) => {
      const tabName = this.tabsArray[idx]
      let compName = ''
      if (tabName.indexOf('全部') != -1) {
        compName = 'SearchAll'
      } else if (tabName.indexOf('商家') != -1) {
        compName = 'SearchBusiness'
      } else if (tabName.indexOf('商品') != -1) {
        compName = 'SearchProduct'
      } else if (tabName.indexOf('景点') != -1) {
        compName = 'SearchThirdPartScenic'
      } else if (tabName.indexOf('月嫂') != -1) {
        compName = 'SearchYueSao'
      } else if (tabName.indexOf('育儿顾问') != -1) {
        compName = 'SearchYuer'
      } else if (tabName.indexOf('酒店') != -1) {
        compName = 'SearchHotel'
      } else if (tabName.indexOf('研学') != -1) {
        compName = 'SearchStudy'
      }
      return compName
    }
  }

  //跳转tab
  tabClicked(idx: number) {
    const tabName = this.tabsArray[idx]
    const tabDefName = TabsDef.find(item => tabName.indexOf(item) != -1) || ''

    this.$newClickTracker({ bizType: '127', pageLevelId: '121012976', clickId: '200001', pageParam: { citycode: getSelectedCityId(), keyword: this.searchKey }, positionParam: { tabname: tabDefName } })
    this.tabSelect = idx
    unbind()
  }

  getComponentIndex(compName: string) {
    const index = findIndex(this.tabsArray, item => startsWith(item, compName))
    this.tabClicked(index)
  }

  beforeDestroy() {
    unbind()
  }
}
